import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateGuestDetails(event) {
    const numberOfPeople = event.target.value
    
    if (numberOfPeople && numberOfPeople > 0) {
      fetch(`/imported_bookings/update_guest_details?number_of_people=${numberOfPeople}`, {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        console.error('Error updating guest details:', error)
      })
    }
  }
}
